import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Container, Navbar, Row } from 'reactstrap';
import Layout from 'HorizontalMenu/Menu';
import Compose from './Compose';
import { useQuery } from 'react-query';
import { queryKeyes } from 'shared/queryKeys';
import { NotificationInbox } from 'VesselMaster/vesselMaster.hooks';
import Sidebar from './Sidebar';
import NotificationList from './NotificationList';
import { useParams } from 'react-router-dom';

const Notification = () => {

    // Fetch URL parameters
    const params = useParams()
    let notification: any = {};// Variable to store notification data
    // Define notification states/tabs like Inbox, Sent, Draft etc.
    const notificationStates = [
        {
            label: 'Inbox',
            icon: 'mdi mdi-email-outline me-2',
            url: queryKeyes.notification.NotificationInbox.url()
        },
        {
            label: 'Sent',
            icon: 'mdi mdi-email-check-outline me-2',
            url: queryKeyes.notification.NotificationSent.url()
        },
        {
            label: 'Draft',
            icon: 'mdi mdi-file-outline me-2',
            url: queryKeyes.notification.NotificationDraft.url()
        },
        {
            label: 'Deleted',
            icon: 'mdi mdi-trash-can-outline me-2',
            url: queryKeyes.notification.NotificationDeleted.url()
        },
        { label: 'Hidden', icon: 'mdi mdi-diamond-stone me-2', },
    ];

    // Function to get URL based on active tab
    const getNotificationUrl = (label: string) => {
        const notification = notificationStates.filter(notification => {
            return notification.label === label
        })
        return notification[0]?.url ?? null
    }

    // State hooks to manage various states
    const [activeTab, setActiveTab] = useState('Inbox'); // State to track active tab
    const [selectedNotification, setSelectedNotification] = useState(null);// To track the selected notification
    const [compose, setCompose] = useState(false);// To handle if user is composing a notification
    const [pageUrl, setPageUrl] = useState(getNotificationUrl(activeTab));// URL to fetch data based on the active tab
    /** Queries start */
    // Fetch notification data based on activeTab and pageUrl using useQuery
    const {
        data: notificationObjects,
        isLoading: notificationLoading,
        isError: notificationError,
    } = useQuery(
        [activeTab, pageUrl],// Query key, updates when activeTab or pageUrl changes
        async () => await NotificationInbox(pageUrl),// Function to fetch data from the API
        {
            enabled: true,// Query is always enabled
            staleTime: Infinity,// Data doesn't become stale immediately
        }
    );

    // Handle tab click to switch between tabs and fetch corresponding data
    function handleTabClick(tabName: string) {
        setActiveTab(tabName); // Update active tab
        setPageUrl(getNotificationUrl(tabName))// Update the page URL based on the selected tab
        setSelectedNotification(null);// Reset selected notification when switching tabs
        setCompose(tabName === 'Compose');// Set compose state based on tab
    }

    // Handle "Back" click from Compose component
    const handleComposeBackClick = () => {
        setCompose(false);
        setActiveTab('Inbox');
    };

    // Handle back button click in NotificationDetails component, clear selected notification
    const handleBackClick = () => {
        setSelectedNotification(null);
    };

    // If the data has loaded and there is no error, check if the URL param `id` is present
    if (!(notificationLoading || notificationError)) {
        if (params.id) {
            // Filter notifications by the id from URL params
            notification = notificationObjects?.results?.filter((notification: any) => notification.notification_id === parseInt(params?.id))
            // if (!notification.length) {
            //     const fetchedNotification = NotificationListHook(parseInt(params.id));
            //     notification = fetchedNotification ? [fetchedNotification] : [{}];
            //     console.log(notification, 'noti')
            // }
        }
    }

    // Update selected notification whenever params.id changes
    useEffect(() => {
        // if(!(notificationObjects.previous || notificationObjects.next)){
        return setSelectedNotification(notification[0] ?? null)// Set the first notification as selected if exists
        // }
    }, [params.id]);

    return (
        <>
            {/* Navbar inside Layout */}

            <Layout children={Navbar} />
            <div className="page-content">
                <Container fluid>
                    <h2 className="mb-4">Notifications</h2>
                    {/* <div className="d-flex"> */}
                    <Row>
                        <Col md={2}>
                            <Sidebar notificationStates={notificationStates} activeTab={activeTab} handleTabClick={handleTabClick} />
                        </Col>
                        <Col md={9} className='ms-5'>
                            <Card className=" shadow-sm mb-4 ">
                                {compose ? (
                                    <Compose handleBackClick={handleComposeBackClick} />
                                ) :
                                    <>
                                        <NotificationList handleNotificationClick={setSelectedNotification}
                                            notificationObjects={notificationObjects} notificationLoading={notificationLoading}
                                            notificationError={notificationError} selectedNotification={selectedNotification} 
                                            handleBackClick={handleBackClick} />
                                        <Row className='p-2 m-1'>
                                            <Col xs="7">Showing {notificationObjects?.results?.length ?? 0} of {notificationObjects?.count}</Col>
                                            <Col xs="5">
                                                <div className="btn-group float-end">
                                                    <Button
                                                        type="button"
                                                        color="success"
                                                        size="sm"
                                                        className="waves-effect"
                                                        disabled={!(notificationObjects?.previous)}
                                                        onClick={() => {
                                                            if (notificationObjects?.previous)
                                                                setPageUrl(notificationObjects?.previous)
                                                        }}
                                                    >
                                                        <i className="fa fa-chevron-left" />
                                                    </Button>
                                                    <Button
                                                        type="button"
                                                        color="success"
                                                        size="sm"
                                                        className="waves-effect"
                                                        disabled={!(notificationObjects?.next)}
                                                        onClick={() => {
                                                            if (notificationObjects?.next)
                                                                setPageUrl(notificationObjects?.next)
                                                        }}
                                                    >
                                                        <i className="fa fa-chevron-right" />
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </>
                                }
                            </Card>
                        </Col>
                    </Row>
                    {/* </div> */}
                </Container>
            </div>
        </>
    );
};

export default Notification;
